import { FaDownload, FaLocationArrow } from "react-icons/fa6";

import { resume, socialMedia } from "@/data";
import MagicButton from "./MagicButton";
import { BackgroundBeams } from "./ui/background-beams";

const Footer = () => {
  return (
    <footer className="w-full pt-20 pb-10" id="contact">
      <div className="flex flex-col md:flex-row items-center justify-center p-4 gap-16 mt-10">
        <div className="flex flex-col items-center justify-center">
          <h1 className="heading lg:max-w-[45vw]">
            Ready to take <span className="text-purple">your</span> digital
            presence to the next level?
          </h1>
          <p className="text-white-200 md:mt-10 my-5 text-center">
            Reach out to me today and let&apos;s discuss how I can help you
            achieve your goals.
          </p>
          <a href="mailto:contact@dipnerreddy.in">
            <MagicButton
              title="Let's get in touch"
              icon={<FaLocationArrow />}
              position="right"
            />
          </a>
        </div>

        <div className="flex flex-col items-center justify-center">
          <h1 className="heading lg:max-w-[45vw] mb-19">
            If you&apos;d like Missing{" "}
            <span className="text-purple">Something...?</span>
          </h1>
          <p></p>
          <p className="text-white-200 mt-20 md:mt-10 text-center">
            explore more details about my professional journey and the projects
            <br></br> I&apos;ve worked on, please feel free to check out my
            resume.
          </p>

          <a
            href="https://drive.google.com/file/d/17kegiT_5Jon7MeebKZ6oSkpO0YnrjrNz/view?usp=drive_link"
            download={resume.link}
            className="flex flex-col items-center"
          >
            <MagicButton
              title="Download Now"
              icon={<FaDownload />}
              position="right"
            />
          </a>
        </div>
      </div>

      <div className="flex mt-16 md:flex-row flex-col justify-between items-center">
        <p className="md:text-base text-sm md:font-normal font-light">
          Copyright © 2024{" "}
          <span className="text-purple">Avuthu Dipner Reddy</span>
        </p>

        <div className="flex items-center md:gap-3 gap-6 mt-1">
          {socialMedia.map((info) => (
            <div
              key={info.id}
              className="w-10 h-10 cursor-pointer flex justify-center items-center backdrop-filter backdrop-blur-lg saturate-180 bg-opacity-75 bg-black-200 rounded-lg border border-black-300"
            >
              <a href={info.link}>
                <img src={info.img} alt="icons" width={20} height={20} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
